// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","search":"search_cptiW","searchInput":"searchInput_En0BP","searchInputIcon":"searchInputIcon_JHYf6"};